import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { NewsRepositoryImpl } from "../../data/repository/news_repository_impl";
import { NewsInterface } from "../../../../core/components/news/domain/interfaces/news_interface";

export const useGetNewsByID = (newsId: string | undefined, initialNews?: NewsInterface) => {
    const repository = new NewsRepositoryImpl();

    return useQuery<NewsInterface, AxiosError>({
        queryKey: ['news', newsId],
        queryFn: () => repository.getNewsById(newsId!),
        retry: 4,
        enabled: !!newsId && !initialNews,
        staleTime: 10 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        initialData: initialNews,
    });
};